import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import { formatCurrencyForTable, formatDateForTable, getBooleanStatusBadgeColors } from '../utils/formatters';
export const createManufacturerShippingColumns = () => [
    {
        key: 'name',
        header: 'Manufacturer',
        sortable: true,
        render: (rate) => rate.name || 'N/A',
    },
    {
        key: 'shipping_amount',
        header: 'Default Shipping',
        sortable: true,
        render: (rate) => formatCurrencyForTable(Number(rate.shipping_amount ?? 0)),
    },
    {
        key: 'is_active',
        header: 'Status',
        sortable: true,
        render: (rate) => {
            const isActive = !!rate.is_active;
            const label = isActive ? 'Active' : 'Inactive';
            const { background, text } = getBooleanStatusBadgeColors(isActive);
            return _jsx(StatusBadge, { label: label, bgColor: background, color: text });
        },
    },
    {
        key: 'updated_at',
        header: 'Updated',
        sortable: true,
        render: (rate) => formatDateForTable(rate.updated_at || rate.created_at),
    },
];
